module.exports = __webpack_public_path__ + "./assets/images/geiger-help.svg";